import React from 'react';
import { useTranslation } from 'react-i18next';
import { Settings, Activity, User, Clock } from 'lucide-react';
import DetailTile from './DetailTile';
import { formatDateTime, getPropertyValue } from '../../../services/traceability-api';

const FactoryProcessingView = ({ isMobile, data }) => {
    const { t } = useTranslation();
    
    const properties = data?.properties || [];
    
    const processStage = getPropertyValue(properties, 'Process Stage') 
        || getPropertyValue(properties, 'Stage') || '—';
    const operator = getPropertyValue(properties, 'Operator') || '—';
    const processStatus = getPropertyValue(properties, 'Process Status') || '—';
    const processedAt = formatDateTime(data?.endTime || data?.startTime);

    return (
        <div className="animate-fade-in p-0">
            <div className="row g-3">
                <DetailTile isMobile={isMobile} icon={<Settings size={16} />} title="Process Stage" value={processStage} />
                <DetailTile isMobile={isMobile} icon={<Activity size={16} />} title="Processed Status" value={processStatus} />
                <DetailTile isMobile={isMobile} icon={<User size={16} />} title="Operator" value={operator} />
                <DetailTile isMobile={isMobile} icon={<Clock size={16} />} title="Processed At" value={processedAt} />
            </div>
        </div>
    );
};

export default FactoryProcessingView;
